import { writable } from 'svelte/store';

// Get the portal url. This is the basis of the search_url.
// Get base url from data-portal-url attribute on body.
// Looks like you can get it with a dataset attribute.
// Have a fallback for when you run this in stand-alone mode.
let url = document.body.dataset && document.body.dataset.portalUrl || 'http://localhost:8080/minaraad';
// Note: when search_url is on a different host or port,
// the query is anonymous.
export const portal_url = writable(url);
export const query = writable({});
